import React, { useEffect, useRef, useState } from 'react';
import { bool, func, number } from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import { AUITable } from '@ancert/aui-table';
import { useNotification } from '@ancert/aui-notification-context';
import {
  AUICalendarFilter,
  AUIClearFilter,
  AUIFilterBar,
  AUIMultiselectFilter,
  AUISearchFilter,
  AUISelectFilter,
  AUIWrapperFilter,
} from '@ancert/aui-filter-bar';
import { SEARCH_OPTIONS, SELECT_ESTADO_OPTIONS, generateFilter, localFilterData } from './filter';
import { getUsersByRole } from '../../services/user.service';
import getColumns from './columns';
import { putAsignarUsuario } from '../../services/denuncias.service';
import { ROL } from '../../lib/role.enum';
import { PAGE_SIZE } from '../../config';
import { ROL_OPTIONS } from '../../constants';

const ModalAsignarDenuncia = ({ show, setShow, id, reload }) => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const { openNotification } = useNotification();
  const [userId, setUserId] = useState();
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [dataFilter, setDataFilter] = useState(null);
  const dataFiltered = localFilterData({ data, filter: dataFilter });

  const getAutoridadUsers = async () => {
    const users = await getUsersByRole(ROL.AUTORIDAD);
    setData(users.data);
  };

  useEffect(() => {
    getAutoridadUsers();
  }, []);

  const onApplyFilter = (filter) => {
    const applyFilter = generateFilter(filter);
    setDataFilter(applyFilter);
    tableRef.current.resetPagination();
  };

  const submitData = async () => {
    const { status } = await putAsignarUsuario({ id, idAuthority: userId });
    if (status === 200) {
      setShow(false);
      reload();
      openNotification({
        title: 'Denuncia asignada',
        content: <div>Denuncia asignada correctamente</div>,
        type: 'success',
        centerButtons: true,
      });
    }
  };

  const buttons = [
    {
      id: 'primary',
      mode: 'primary',
      label: 'Asignar',
      disabled: submitDisabled,
      onClick: submitData,
    },
    {
      id: 'tertiary',
      mode: 'tertiary',
      label: 'Cancelar',
      disabled: false,
      onClick: setShow,
    },
  ];

  return (
    <AUIModal
      size="xxl"
      title="Asignar denuncia a usuario"
      show={show}
      actionButtons={buttons}
      autoHeight
      onClose={setShow}
    >
      <AUIFilterBar
        tagBar
        onSubmit={onApplyFilter}
        onReset={() => {
          setDataFilter(null);
        }}
      >
        <AUIWrapperFilter position="left">
          <AUISearchFilter name="filter" options={SEARCH_OPTIONS} />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="center">
          <AUICalendarFilter name="date" label="Fecha denuncia" selectionMode="range" />
          <AUISelectFilter label="Estado" name="status" options={SELECT_ESTADO_OPTIONS} />
          <AUIMultiselectFilter
            label="Rol"
            name="role"
            options={ROL_OPTIONS.filter((rol) => rol.value !== ROL.DENUNCIANTE)}
          />
        </AUIWrapperFilter>
        <AUIWrapperFilter position="right">
          <AUIClearFilter label="Reiniciar filtros" />
        </AUIWrapperFilter>
      </AUIFilterBar>
      <AUITable
        ref={tableRef}
        className="u-mt-16"
        data={dataFiltered}
        columns={getColumns()}
        forcePagination
        pageSize={PAGE_SIZE.LISTADO_ASIGNAR_DENUNCIA}
        totalData={dataFiltered?.length}
        onClickRow={(row) => {
          setUserId(row.id);
          setSubmitDisabled(false);
        }}
      />
    </AUIModal>
  );
};
ModalAsignarDenuncia.propTypes = {
  show: bool,
  setShow: func.isRequired,
  id: number,
  reload: func.isRequired,
};
ModalAsignarDenuncia.defaultProps = {
  show: false,
  id: null,
};

export default ModalAsignarDenuncia;
